import { render, staticRenderFns } from "./goods-in-list.vue?vue&type=template&id=61c3572b"
import script from "./goods-in-list.vue?vue&type=script&lang=js"
export * from "./goods-in-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports